import React from "react";
import { ReferenceLine } from "recharts";

export interface ThresholdReferenceLineProps {
	y: number;
	color: string;
}

export const ThresholdReferenceLine: React.FC<ThresholdReferenceLineProps> = ({ y, color }) => (
	<ReferenceLine stroke={color} strokeDasharray="8 4" strokeWidth="2" y={y} zIndex={500} />
);
